import Vue from 'vue'
import axios from 'axios'
import i18n from '@/i18n'

Vue.prototype.$axios = axios

const urlApi = process.env.VUE_APP_BASE_URL

const apiSecond = axios.create({
	baseURL: process.env.VUE_APP_API_MAIN,
})

apiSecond.interceptors.request.use(
	(config) => {
		// Пишем заголовки напрямую в config.headers (а не в headers.common):
		// при повторе запроса после refresh у config.headers уже нет поля common.
		config.headers = config.headers || {}
		const access_token = localStorage.getItem('access_token')
		if (access_token) {
			config.headers['Authorization'] = `Bearer ${access_token}`
		}

		// Use current i18n locale instead of localStorage to ensure consistency
		// This ensures the API receives the same language as the current page
		const currentLocale = i18n.locale || localStorage.getItem('selected_lang_locale') || 'ru'
		config.headers['Accept-Language'] = currentLocale

		return config
	},
	(error) => {
		return Promise.reject(error)
	},
)

// Функция обновления токена регистрируется из store (см. src/store/index.js),
// чтобы избежать циклического импорта store <-> axios.
let tokenRefresher = null
function setTokenRefresher(fn) {
	tokenRefresher = fn
}

// Запросы, для которых 401 — штатный ответ (неверный логин/код), а не просроченный токен
const AUTH_URLS = ['v1/login', 'v1/user/refreshToken']
function isAuthRequest(config) {
	const url = (config && config.url) || ''
	return AUTH_URLS.some((u) => url.includes(u))
}

apiSecond.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		const status = error?.response?.status
		const config = error?.config

		if (
			status === 401 &&
			config &&
			!config._retried &&
			!isAuthRequest(config) &&
			tokenRefresher &&
			localStorage.getItem('refresh_token')
		) {
			config._retried = true
			const refreshed = await tokenRefresher()
			if (refreshed) {
				// Новый Authorization подставит request-interceptor из localStorage
				return apiSecond.request(config)
			}
		}
		throw error
	},
)

export { axios, urlApi, apiSecond, setTokenRefresher }
